import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Dispatch, SetStateAction, useState } from 'react';

import { isValidInput } from '../utils/validations';

interface ResonOfRejectionProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setRejectionRsn: Dispatch<SetStateAction<string>>;
  rejectionRsn: string;
  selectedId: string;
}

export default function ResonOfRejection({
  open,
  onClose,
  setOpen,
  rejectionRsn,
  setRejectionRsn,
  selectedId,
}: ResonOfRejectionProps) {
  const [error, setError] = useState(false);
  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={() => {
        setRejectionRsn('');
        setOpen(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Rejection Reason</h2>
            <div
              className="btn-close"
              onClick={() => {
                setRejectionRsn('');
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>Add Reason</label>
              <TextField
                placeholder="Enter Reason"
                fullWidth
                hiddenLabel
                multiline
                maxRows={5}
                minRows={5}
                value={rejectionRsn}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setRejectionRsn(val.target.value);
                  }
                }}
              />
              {rejectionRsn.length === 0 && error && (
                <div
                  className=""
                  style={{
                    color: 'red',
                  }}
                >
                  This field is required
                </div>
              )}
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setOpen(false);
                  setRejectionRsn('');
                }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => {
                  if (rejectionRsn.length <= 0) {
                    setError(true);
                    return;
                  }
                  setError(false);
                  onClose();
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
